import { IFeature } from 'mod/featureV2/interface';

export const swiperToggleBanner:IFeature = {
    type: 'swiperToggleBanner',
    moduleId: 'swiperToggleBanner',
    title: 'swiperToggleBanner',
    description: 'Description',
    config: {
        width: 290,
        height: 322,
        spaceBetweenColumns: 10,
    },
    list: new Array(10).fill(void 0).map(() => ({
        src: 'asset/width-736/picture/7489e8d135942772879b84aea33e5781.png',
        href: '/vivosun-4x4-mylar-hydroponic-grow-tent-for-indoor-plant-growing-48x48x80-p63933466594377747-v58820960379609764',
    }))
};